import React from 'react';
import { styled } from '@mui/material';
import { ITheme } from 'theme/types';
import { SubTitleTextProps } from './types';

const PREFIX = 'SubTitleText';

const classes = {
  subtitle: `${PREFIX}-subtitle`,
};

const Root = styled('h2')(({ theme }) => ({
  [`&.${classes.subtitle}`]: {
    fontSize: '0.75rem',
    color: theme.palette.primary.main,
    fontWeight: 'normal',
  },
}));

const SubTitleText = (props: SubTitleTextProps) => {
  const { subTitle } = props;

  return <Root className={classes.subtitle}>{subTitle}</Root>;
};

export default SubTitleText;
